@if (isOfertaStandaloneLanding()) {
  <main class="block min-h-screen w-full">
    <router-outlet />
  </main>
} @else {
  <div class="min-h-screen flex flex-column bg-gray-50" [style.padding-bottom]="isMobile() ? 'calc(60px + env(safe-area-inset-bottom, 0px))' : '0px'">
    <!-- 1. Header (Fixed at the top) -->
    <app-header class="fixed top-0 left-0 w-full flex-shrink-0" />

    <!-- 2. Main Layout Area (Below Header, Above Footer) -->
    <div class="flex flex-1 relative min-h-screen app-content-row">
      <app-side-bar />

      <main class="flex-1 min-w-0 transition-all transition-duration-300">
        <div class="p-3 lg:p-4 min-h-full">
          <router-outlet />
        </div>
      </main>
    </div>

    <!-- 3. Footer (Always at the bottom, full width) -->
    <app-footer class="flex-shrink-0 relative z-5"
      [class.content-pushed]="shouldPushContent()"
     />
    <app-help-chat-widget />
    <app-mobile-bottom-nav />
  </div>
}

<app-loading [global]="true" text="Processando..." subtext="Aguarde um momento" />
